const CartEvent = {
  ADD_PRODUCT: 'SC_CART_ADD_PRODUCT',
  REMOVE_PRODUCT: 'SC_CART_REMOVE_PRODUCT',
  CLEAR: 'SC_CART_CLEAR',
  INIT: 'SC_CART_INIT',
  UPDATE_PRODUCT: 'SC_CART_UPDATE_PRODUCT'
}

export default CartEvent
